export const JOHN_DEERE_TAG_PREFIX = '(JD-';

export const JOHN_DEERE_TAG_SUFFIX = ')';

export const JOHN_DEERE_SHORT_ID_LENGTH = 8;
